import { CF_ASSET_PATH } from "utilities/constants";
import { CF_VIDEO_TYPE_DICTIONARY } from "../constants";
import { CfVideoProps, VideoProps } from "../types";
import { getDeepVal } from "utilities/utils";
import React from "react";
import Video from "..";

export const convertCfVideoProps = ({
  autoplay,
  loop,
  muted,
  previewImage,
  openInModal = false,
  videoLocal,
  videoType,
  videoYoutube,
}: CfVideoProps): VideoProps => {
  return {
    autoplay: autoplay || false,
    loop: loop || false,
    muted: muted || false,
    openInModal: openInModal || false,
    videoYoutube: videoYoutube || "",
    previewImage:
      getDeepVal(previewImage, `[0].imageDesktop.${CF_ASSET_PATH}`) ?? "",
    videoLocal: getDeepVal(videoLocal, CF_ASSET_PATH) ?? "",
    videoType: getDeepVal(CF_VIDEO_TYPE_DICTIONARY, videoType) ?? "",
  };
};

const CfVideo = (props: CfVideoProps) => {
  const videoProps = convertCfVideoProps(props);
  return <Video {...videoProps} />;
};

export default CfVideo;
